input, .uppercased {
  text-transform: uppercase;
}

@media print {
  .container {
    padding: 0 !important;
    border: 0 !important;
    outline: 0 !important;
    box-shadow: none !important;
  }
}

.container {
  padding: 3rem;
  border-radius: 0;
}

@media screen and (max-width: 420px) {
  .container {
    padding: 2rem 1rem;
  }
}

.container + .container {
  margin-top: 0;
}

.container .header {
  display: flex;
  align-items: baseline;
}

.header .iconAvatar {
  margin-right: 0.5rem;
  background-color: #4cc6f1; /* styles.js: Antenna Blue */
}

@media print {
  .header .iconAvatar {
    color: black;
    border: 1px solid black;
  }
}

.container .title {
  display: flex;
  align-items: center;
  margin-bottom: 0.75em;
}

.container .headerDivider {
  margin-bottom: 1.5rem;
}
